namespace RioERP.Users {
    export interface CustomersSMSForm {
        Status: Serenity.EnumEditor;
        RowIds: Serenity.StringEditor;
    }

    export class CustomersSMSForm extends Serenity.PrefixedContext {
        static formKey = 'Users.CustomersSMS';
        private static init: boolean;

        constructor(prefix: string) {
            super(prefix);

            if (!CustomersSMSForm.init)  {
                CustomersSMSForm.init = true;

                var s = Serenity;
                var w0 = s.EnumEditor;
                var w1 = s.StringEditor;

                Q.initFormType(CustomersSMSForm, [
                    'Status', w0,
                    'RowIds', w1
                ]);
            }
        }
    }
}
